import React from 'react'
import './index.css'

const PreNav = () => {
  return (
  <>
  <style>
    
  </style>
  <div>
  <p className='text-center preNav'>Shop up to 50% OFF on your favourite summer style from our End of Season Sale <b> now  </b> <span className='Track'>Track</span> </p>

  </div>
  </>
  )
}

export default PreNav
